import { AxiosResponse } from 'axios';
import { EEBarrier } from '../../../../Model/Dto/EmploymentEquity/Plan/EEBarriers';
import { axiosCoreInstance } from '../../../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.Barriers';

export const BarrierService = {
    GetBarrier: (id: string): Promise<AxiosResponse<EEBarrier.DtoIn>> => axiosCoreInstance.get(`${ApiUrls.Barriers}/${id}`),
    SearchBarriers: (searchRequest: EEBarrier.SearchRequest):
        Promise<AxiosResponse<EEBarrier.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchBarriers, searchRequest),
    CreateBarrier: (barrier: EEBarrier.DtoOut): Promise<AxiosResponse<EEBarrier.DtoOut>> => axiosCoreInstance.post(ApiUrls.Barriers, barrier),
    UpdateBarrier: (barrier: EEBarrier.DtoOut): Promise<AxiosResponse<EEBarrier.DtoOut>> => axiosCoreInstance.put(ApiUrls.Barriers, barrier),
    DeleteBarrier: (id: string): Promise<AxiosResponse<void>> => axiosCoreInstance.delete(`${ApiUrls.Barriers}/${id}`),
    getBarrierCategories: (): Promise<AxiosResponse<EEBarrier.BarrierCategory[]>> => axiosCoreInstance.get(ApiUrls.BarrierCategories)
}


